module.exports = __webpack_public_path__ + "img/4.93ad1818.jpg";